import SectionHero from '@/components/SectionHero';
import DefaultSolutionTemplate from '@/components/templates/Solution';
import { sdk } from '@/lib/graphcms';

export default function ApplicationContent({ solution }) {
  return (
    <DefaultSolutionTemplate page={solution}>
      <SectionHero
        title="Embrace the era of application content"
        description="Not all content is marketing, which is why most CMS find their limits at websites. In the age of streaming platforms, SaaS products, omnichannel eCommerce, and IoT, you need more than just a CMS."
      />
    </DefaultSolutionTemplate>
  );
}

export const getStaticProps = async ({ preview = false }) => {
  const { solution } = await sdk({ preview }).useCasePage({
    slug: 'application-content',
  });

  if (!solution) {
    return {
      notFound: true,
    };
  }

  return {
    props: {
      preview,
      solution,
    },
    revalidate: 3600,
  };
};
